import { useFeatureFlags } from 'core/app/AppContext';

export const useIsAdditionalBranchesFlagEnabled = () => {
  const { flagEnabled } = useFeatureFlags();

  return flagEnabled('ld-add-branches');
};
